import { AppBar, Toolbar } from "@mui/material";
import { useLocation } from "react-router-dom";
import { MenuButton } from "components/AppNavigation/MegaMenu/lib";
import { MegaMenu } from "components/AppNavigation/MegaMenu";
import { useLinks } from "hooks/useLinks";
import { AppBarLogo, AppBarUser } from "./lib";
import { appBarStyles } from "./styles";
import HideOnScroll from "./lib/HideOnScroll";

const AppBarComponent = () => {
	const location = useLocation();
	const links = useLinks();
	const isEliteDeals = location.pathname.startsWith(links.elite_deals.path);

	return (
		<HideOnScroll isDisabled>
			<AppBar position="fixed" sx={appBarStyles(isEliteDeals)}>
				<Toolbar sx={{ padding: "0 8px" }}>
					<AppBarLogo />
					<AppBarUser />
					<MenuButton />
					<MegaMenu />
				</Toolbar>
			</AppBar>
		</HideOnScroll>
	);
};

export default AppBarComponent;
